import { DEPRECATED_ApiManager } from "../../../api";

import {
  GetRunsParams,
  GetRunsResponse,
  GetThreadResponse,
  SearchAlertsParams,
  SearchAlertsResponse,
} from "./types";

export const createSmartAlertsDebugApi = (api: DEPRECATED_ApiManager) => ({
  searchAlerts: (params: SearchAlertsParams): Promise<SearchAlertsResponse> => {
    const queryParams = new URLSearchParams();
    if (params.email) {
      queryParams.set("email", params.email);
    }
    if (params.smart_alert_id) {
      queryParams.set("smart_alert_id", params.smart_alert_id);
    }
    if (params.spreadsheet_id) {
      queryParams.set("spreadsheet_id", params.spreadsheet_id);
    }
    if (params.run_id) {
      queryParams.set("run_id", params.run_id);
    }
    if (params.limit !== undefined) {
      queryParams.set("limit", String(params.limit));
    }
    if (params.offset !== undefined) {
      queryParams.set("offset", String(params.offset));
    }
    const qs = queryParams.toString();
    return api.request({
      method: "GET",
      url: `/api/retool/smart_alerts/search${qs ? `?${qs}` : ""}`,
    });
  },

  getRuns: (smartAlertId: string, params?: GetRunsParams): Promise<GetRunsResponse> => {
    const queryParams = new URLSearchParams();
    if (params?.limit !== undefined) {
      queryParams.set("limit", String(params.limit));
    }
    const qs = queryParams.toString();
    return api.request({
      method: "GET",
      url: `/api/retool/smart_alerts/${smartAlertId}/runs${qs ? `?${qs}` : ""}`,
    });
  },

  getThread: (smartAlertId: string): Promise<GetThreadResponse> => {
    return api.request({
      method: "GET",
      url: `/api/retool/smart_alerts/${smartAlertId}/thread`,
    });
  },
});
